import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import CookieBanner from '../../components/feature/CookieBanner';
import StructuredData from '../../components/base/StructuredData';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';

const ServiciosPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);

    document.title = 'Servicios de Vaciado de Pisos y Locales en Mollet | JUSTCLEAN';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Servicios profesionales de vaciado de pisos, locales, retirada de muebles y limpieza Diógenes en Mollet del Vallès. Presupuesto sin compromiso ☎️ 602 36 59 96'
      );
    }
  }, []);

  const serviciosDetallados = [
    {
      title: 'Vaciado de pisos y casas',
      description:
        'Servicio completo de vaciado de viviendas en Mollet del Vallès, Parets del Vallès, Montmeló y toda la comarca del Vallès Oriental. Nos encargamos de retirar todos los enseres, muebles, electrodomésticos y objetos personales, dejando el piso completamente vacío y limpio.',
      image:
        'https://public.readdy.ai/ai/img_res/d21284f9095b221d67e6b36db7632325.jpg',
      beneficios: [
        'Vaciado completo de pisos para herencias, mudanzas o desahucios',
        'Retirada de todo tipo de enseres y objetos personales',
        'Limpieza profunda tras el vaciado',
        'Gestión legal de residuos con certificado',
        'Servicio en barrios de Mollet: Centre, Plana Lledó, Can Borrell, Santa Rosa',
      ],
      casosTypicos: [
        'Herencias: Vaciado de pisos tras fallecimiento de familiares',
        'Mudanzas: Retirada de enseres que no se llevan al nuevo domicilio',
        'Desahucios: Vaciado urgente de viviendas',
        'Renovaciones: Preparación de pisos para reforma integral',
      ],
    },
    {
      title: 'Vaciado de locales comerciales',
      description:
        'Especialistas en vaciado de locales comerciales, oficinas, naves industriales y espacios comerciales en Mollet del Vallès y Vallès Oriental. Ideal para traspasos, cierres de negocio o renovaciones completas de espacios comerciales.',
      image:
        'https://readdy.ai/api/search-image?query=empty%20commercial%20space%20interior%20clean%20cleared%20retail%20store%20office%20white%20walls%20open%20floor%20plan%20bright%20lighting%20professional%20clearance%20ready%20for%20new%20business%20modern%20minimalist&width=800&height=600&seq=servicio-vaciado-locales&orientation=landscape',
      beneficios: [
        'Vaciado de locales comerciales, oficinas y naves',
        'Retirada de mobiliario comercial, estanterías y equipamiento',
        'Desmontaje de instalaciones si es necesario',
        'Coordinación con horarios comerciales para no molestar',
        'Servicio en Mollet, Granollers, Parets y toda la comarca',
      ],
      casosTypicos: [
        'Traspasos: Dejar el local listo para el nuevo inquilino',
        'Cierres: Vaciado completo tras cierre de negocio',
        'Renovaciones: Preparación para reforma del espacio comercial',
        'Cambios de actividad: Adaptación del local a nuevo uso',
      ],
    },
    {
      title: 'Retirada de muebles y electrodomésticos',
      description:
        'Servicio especializado en recogida y retirada de muebles, electrodomésticos y enseres voluminosos en Mollet del Vallès y alrededores. Nos encargamos de la gestión responsable de residuos, reciclaje y donación de objetos en buen estado.',
      image:
        'https://readdy.ai/api/search-image?query=furniture%20removal%20service%20workers%20carrying%20sofa%20couch%20professional%20movers%20in%20uniform%20clean%20organized%20efficient%20service%20residential%20setting%20bright%20daylight%20careful%20handling&width=800&height=600&seq=servicio-retirada-muebles&orientation=landscape',
      beneficios: [
        'Retirada de muebles, sofás, armarios y todo tipo de mobiliario',
        'Recogida de electrodomésticos: neveras, lavadoras, televisores',
        'Gestión de residuos con puntos limpios autorizados',
        'Donación de muebles en buen estado a ONGs locales',
        'Servicio en Mollet, Montmeló, La Llagosta, Martorelles',
      ],
      casosTypicos: [
        'Renovación de mobiliario: Retirada de muebles viejos',
        'Herencias: Gestión de enseres que no se aprovechan',
        'Mudanzas: Retirada de objetos que no caben en el nuevo piso',
        'Limpieza de trasteros: Vaciado de trasteros acumulados',
      ],
    },
    {
      title: 'Limpieza por síndrome de Diógenes y suciedad extrema',
      description:
        'Servicio especializado y discreto para casos de síndrome de Diógenes, acumulación compulsiva y suciedad extrema en Mollet del Vallès y comarca. Tratamos cada situación con máxima sensibilidad, respeto y profesionalidad, trabajando en coordinación con servicios sociales y familias.',
      image:
        'https://readdy.ai/api/search-image?query=professional%20deep%20cleaning%20service%20worker%20in%20protective%20gear%20cleaning%20extreme%20mess%20disinfection%20sanitation%20thorough%20cleaning%20process%20safety%20equipment%20white%20clean%20background%20professional%20service&width=800&height=600&seq=servicio-limpieza-diogenes&orientation=landscape',
      beneficios: [
        'Servicio discreto y confidencial garantizado',
        'Equipo especializado en casos de acumulación compulsiva',
        'Limpieza profunda y desinfección completa',
        'Coordinación con servicios sociales y familias',
        'Trato humano y respetuoso en todo momento',
      ],
      casosTypicos: [
        'Síndrome de Diógenes: Limpieza de viviendas con acumulación extrema',
        'Suciedad extrema: Desinfección y limpieza profunda',
        'Casos sociales: Colaboración con trabajadores sociales',
        'Viviendas insalubres: Recuperación de espacios habitables',
      ],
    },
    {
      title: 'Pintura final',
      description:
        'Servicio de pintura profesional para dejar tu piso o local listo para alquilar o vender en Mollet del Vallès y Vallès Oriental. Acabados de calidad que revalorizan tu propiedad y la hacen más atractiva para futuros inquilinos o compradores.',
      image:
        'https://readdy.ai/api/search-image?query=professional%20painter%20painting%20white%20wall%20interior%20room%20clean%20fresh%20paint%20roller%20brush%20bright%20clean%20workspace%20quality%20finish%20residential%20painting%20service%20modern%20apartment&width=800&height=600&seq=servicio-pintura&orientation=landscape',
      beneficios: [
        'Pintura de paredes y techos con acabado profesional',
        'Preparación de superficies: lijado, masillado, imprimación',
        'Pinturas de calidad con garantía de durabilidad',
        'Asesoramiento en colores neutros que favorecen la venta/alquiler',
        'Servicio rápido para no retrasar la puesta en el mercado',
      ],
      casosTypicos: [
        'Preparación para alquiler: Dejar el piso impecable',
        'Venta de inmuebles: Mejorar la presentación del piso',
        'Tras vaciado: Pintura completa después de vaciar',
        'Renovación: Actualizar el aspecto de la vivienda',
      ],
    },
    {
      title: 'Pequeñas reparaciones',
      description:
        'Servicio de pequeñas reparaciones y arreglos menores para la entrega de llaves en Mollet del Vallès. Nos encargamos de esos detalles que marcan la diferencia: grifería, cerraduras, enchufes, tiradores y otros elementos que necesitan ajuste o sustitución.',
      image:
        'https://readdy.ai/api/search-image?query=handyman%20repairing%20fixing%20door%20lock%20handle%20professional%20maintenance%20worker%20tools%20home%20repair%20service%20detailed%20work%20quality%20craftsmanship%20residential%20setting%20clean%20organized&width=800&height=600&seq=servicio-reparaciones&orientation=landscape',
      beneficios: [
        'Reparación de grifería, cerraduras y manillas',
        'Arreglo de enchufes, interruptores y pequeñas instalaciones',
        'Sustitución de tiradores, bisagras y herrajes',
        'Reparación de pequeños desperfectos en paredes',
        'Todo listo para la entrega de llaves sin preocupaciones',
      ],
      casosTypicos: [
        'Entrega de llaves: Arreglos finales antes de entregar',
        'Inspecciones: Solucionar problemas detectados en revisiones',
        'Mantenimiento: Pequeños arreglos acumulados',
        'Adecuación: Ajustes para cumplir normativas',
      ],
    },
  ];

  const serviciosAdicionales = [
    {
      icon: 'ri-building-line',
      title: 'Limpieza de comunidades',
      description: 'Limpieza de zonas comunes, escaleras y portales',
    },
    {
      icon: 'ri-virus-line',
      title: 'Desinfección',
      description: 'Desinfección profesional de espacios',
    },
    {
      icon: 'ri-24-hours-line',
      title: 'Servicio urgente 24h',
      description: 'Disponibilidad inmediata para emergencias',
    },
    {
      icon: 'ri-team-line',
      title: 'Coordinación con vecinos',
      description: 'Gestión con comunidades de propietarios',
    },
  ];

  const faqServicios = [
    {
      pregunta: '¿Qué incluye el vaciado completo de un piso?',
      respuesta:
        'El vaciado completo incluye la retirada de todos los muebles, electrodomésticos, enseres, ropa, objetos personales y cualquier elemento presente en la vivienda. También incluimos la limpieza profunda posterior, barrido de escombros y gestión legal de todos los residuos con certificado. Dejamos el piso completamente vacío y limpio, listo para pintar, reformar o entregar llaves.',
    },
    {
      pregunta: '¿Cómo gestionáis los residuos del vaciado?',
      respuesta:
        'Gestionamos todos los residuos de forma legal y responsable. Los muebles y objetos en buen estado los donamos a organizaciones benéficas de Mollet del Vallès y comarca. Los electrodomésticos y residuos especiales los llevamos a puntos limpios autorizados. El resto de residuos se gestiona según normativa vigente. Entregamos certificado de gestión de residuos si lo necesitas.',
    },
    {
      pregunta: '¿Cuánto tarda el vaciado de un piso medio?',
      respuesta:
        'Un piso estándar de 70-80m² suele vaciarse en 1-2 días laborables. Pisos más grandes o con mucha acumulación pueden requerir 3-4 días. En casos de síndrome de Diógenes, el tiempo depende del nivel de acumulación, pudiendo extenderse hasta una semana. Siempre te damos una estimación precisa tras la visita inicial gratuita.',
    },
    {
      pregunta: '¿Ofrecéis presupuesto sin compromiso?',
      respuesta:
        'Sí, todos nuestros presupuestos son gratuitos y sin ningún compromiso. Puedes llamarnos al 602 36 59 96 o escribirnos por WhatsApp para una primera valoración telefónica. Si lo prefieres, visitamos el piso o local en Mollet del Vallès o comarca sin coste para darte un presupuesto detallado y ajustado a tus necesidades específicas.',
    },
  ];

  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Vaciado de Pisos y Limpieza',
    provider: {
      '@type': 'LocalBusiness',
      name: 'JUSTCLEAN Mollet del Vallès',
      telephone: '+34602365996',
      areaServed: 'Mollet del Vallès, Vallès Oriental',
    },
    areaServed: 'Mollet del Vallès, Parets del Vallès, Montmeló, Granollers, Vallès Oriental',
  };

  return (
    <div className={`min-h-screen transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <StructuredData data={structuredData} />
      <Header />

      <main>
        <section
          className="relative h-96 flex items-center justify-center"
          style={{
            backgroundImage:
              'url(https://readdy.ai/api/search-image?query=professional%20cleaning%20service%20equipment%20tools%20organized%20workspace%20cleaning%20supplies%20modern%20efficient%20service%20industry%20bright%20clean%20environment%20quality%20professional%20setup&width=1920&height=600&seq=hero-servicios-justclean&orientation=landscape)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-dark/60"></div>
          <div className="relative z-10 text-center px-4">
            <nav className="text-white/70 text-sm mb-4">
              <Link to="/" className="hover:text-white">
                Inicio
              </Link>
              <span className="mx-2">&gt;</span>
              <span className="text-white">Servicios</span>
            </nav>
            <h1 className="text-5xl md:text-6xl font-bold text-white">
              Servicios de Vaciado y Limpieza en Mollet del Vallès
            </h1>
          </div>
        </section>

        {serviciosDetallados.map((servicio, index) => (
          <section
            key={index}
            className={`py-24 ${index % 2 === 0 ? 'bg-white' : 'bg-secondary/10'}`}
          >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div
                className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div className="inline-block bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-semibold mb-4">
                    Servicio {index + 1}
                  </div>

                  <h2 className="text-3xl md:text-4xl font-bold text-dark mb-6">{servicio.title}</h2>

                  <p className="text-gray-700 text-lg leading-relaxed mb-8">{servicio.description}</p>

                  <div className="mb-8">
                    <h3 className="text-xl font-bold text-dark mb-4">Beneficios del servicio:</h3>
                    <ul className="space-y-3">
                      {servicio.beneficios.map((beneficio, idx) => (
                        <li key={idx} className="flex items-start space-x-3">
                          <i className="ri-checkbox-circle-fill text-primary text-xl mt-0.5 flex-shrink-0"></i>
                          <span className="text-gray-700">{beneficio}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mb-8">
                    <h3 className="text-xl font-bold text-dark mb-4">Casos típicos:</h3>
                    <ol className="space-y-2">
                      {servicio.casosTypicos.map((caso, idx) => (
                        <li key={idx} className="flex items-start space-x-3">
                          <span className="text-primary font-bold flex-shrink-0">{idx + 1}.</span>
                          <span className="text-gray-700">{caso}</span>
                        </li>
                      ))}
                    </ol>
                  </div>

                  <Link
                    to="/contacto"
                    className="inline-flex items-center space-x-2 bg-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-all duration-200 cursor-pointer whitespace-nowrap"
                  >
                    <span>Solicitar este servicio</span>
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>

                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="relative rounded-2xl overflow-hidden shadow-xl">
                    <img
                      src={servicio.image}
                      alt={servicio.title}
                      className="w-full h-auto object-cover object-top"
                    />
                    <div className="absolute top-4 left-4 bg-primary text-white px-4 py-2 rounded-lg">
                      <i className="ri-star-fill mr-2"></i>
                      <span className="font-semibold">Servicio Premium</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ))}

        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4">Servicios adicionales</h2>
              <div className="w-16 h-1 bg-primary mx-auto"></div>
              <p className="mt-6 text-lg text-gray-700 max-w-3xl mx-auto">
                Además de nuestros servicios principales, ofrecemos soluciones complementarias para cubrir todas tus necesidades en Mollet del Vallès y comarca.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {serviciosAdicionales.map((servicio, index) => (
                <div
                  key={index}
                  className="bg-secondary/10 rounded-xl p-6 text-center hover:bg-secondary/20 transition-colors duration-200"
                >
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-primary/10 rounded-full">
                    <i className={`${servicio.icon} text-3xl text-primary`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-dark mb-2">{servicio.title}</h3>
                  <p className="text-gray-600 text-sm">{servicio.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-24 bg-secondary/10">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4">
                Preguntas frecuentes sobre servicios
              </h2>
              <div className="w-16 h-1 bg-primary mx-auto"></div>
            </div>

            <div className="space-y-4">
              {faqServicios.map((faq, index) => (
                <div key={index} className="bg-white rounded-lg overflow-hidden">
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
                  >
                    <h3 className="text-lg font-semibold text-dark pr-8">{faq.pregunta}</h3>
                    <i
                      className={`ri-arrow-down-s-line text-2xl text-primary transition-transform duration-200 flex-shrink-0 ${
                        openFaq === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </button>

                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openFaq === index ? 'max-h-96' : 'max-h-0'
                    }`}
                  >
                    <div className="p-6 pt-0 text-gray-700 leading-relaxed">{faq.respuesta}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-12">
              <Link
                to="/faq"
                className="inline-flex items-center space-x-2 text-primary font-semibold hover:underline cursor-pointer"
              >
                <span>Ver todas las preguntas frecuentes</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        <section className="py-16 bg-gradient-to-r from-primary to-secondary">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              ¿Necesitas alguno de nuestros servicios?
            </h2>

            <p className="text-white/90 text-lg mb-8">
              Contacta con nosotros y recibe tu presupuesto personalizado sin compromiso
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a
                href="tel:+34602365996"
                className="inline-flex items-center justify-center space-x-2 bg-white text-primary px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-xl"></i>
                <span>Llamar Ahora</span>
              </a>

              <Link
                to="/contacto"
                className="inline-flex items-center justify-center space-x-2 border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-primary transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-text-line text-xl"></i>
                <span>Solicitar Presupuesto</span>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
      <CookieBanner />
    </div>
  );
};

export default ServiciosPage;